import useGame from "./use-game";

export default function useSchool(id: SchoolId) {

    const { game, error, isLoading } = useGame();

    return {
        school: game?.schools.find(s => s.id === id),
        error,
        isLoading
    }
}
